<template>
    <div style="display: flex; flex-direction: column;">
        <div style="flex: 1; overflow-y: hidden; position: relative; overflow-x: hidden;">
            <OptionBtn :setIsShowTopBtn="setIsShowTopBtn" :pageName="PAGE_NAME.TRAINING"></OptionBtn>
            <Transition name="fade">
                <div v-show="is_soccer_learn_loaded" style="overflow: hidden;height: 100%;">
                    <div :style="{ height: $GlobalStore.statusBarHeight() + 'px' }"></div>
                    <InfinityScroll ref="infinity" v-if="is_soccer_learn_loaded" @convey-scroll-top="__conveyScrollTop" v-show="curType === BTN_TYPE.LEARN" :detect-scroll="detectScroll" :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="curViewTab === VIEW_TAB.POPULAR ? isEnableNextPageHandlePopular : isEnableNextPageHandle" style="height: 100%; overflow: hidden; scroll-behavior: smooth;">
                        <div style="position: sticky; min-height: 56px; top: 0; background-color: #fff; padding: 8px 0; width: 100%; z-index: 5;">
                            <div style=" display: flex; justify-content: center; margin-top: 6px;">
                                <div style="display: flex; align-items: center; gap: 6px;">
                                    <!-- <div>
                                        <img style="width: 20px;" :src="require('@/assets/img/ground_news.png')" alt="">
                                    </div> -->
                                    <div style="font-weight: 700; line-height: 24px;">그라운드</div>
                                </div>
                            </div>
                            <div v-show="!isHideLearn" style="padding: 0 12px; padding-top: 4px; flex: 1;">
                                <ProgressBar :hideProgressBar="completeAction" :progressHeight="4" :isStart="isStartLearn"></ProgressBar>
                            </div>
                        </div>
                        <div style="">
                            <!-- <div style="padding: 0 12px; border-bottom: 1px solid #f5f5f5; margin-top: 12px;">
                                <div style="font-size: 15px; font-weight: 700; line-height: 21px; margin-bottom: 10px;">🔥 이렇게 훈련해 봐 ⚽️</div>
                                <swiper v-if="banne rList.length > 0" style="margin: 0 -12px; padding: 0 12px;" ref="swiper" :options="swiperOption" role="tablist">
                                    스와이프 필요하면 아래 div태그를 swiper-slide로 바꾸면 됨
                                    <swiper-slide v-for="each, index in bannerList" :key="index + 'banner_learn'" style="width: 100%; display: flex; background: linear-gradient(180deg, rgba(33, 15, 3, 0.12) 15%, rgba(255, 255, 255, 0) 30%, rgba(0, 0, 0, 0.6) 80%); flex-direction: column; height: 440px; position: relative; border-radius: 12px; overflow: hidden; flex-shrink: 0;" role="tab">
                                        <div style="width: 154px; height: 28px; line-height: 28px; font-weight: 700; font-size: 14px; color: var(--color-main); text-align: center; margin-left: 24px; border-radius: 21px; border: 1px solid #fff; margin-top: 25px; background: #FFFFFF33;">
                                            WEEKLY CHALLENGE
                                        </div>
                                        <div style="position: absolute; overflow: hidden; z-index: -1;">
                                            <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.media_path1" alt="">
                                        </div>
                                        <div @click="showBannerDetail(each.idx)" style="width: 100%; height: 100%; margin: 0 auto; overflow: hidden; position: relative; padding: 0 24px;">
                                            <div style="position: relative; z-index: 2; height: 100%; display: flex; flex-direction: column; justify-content: flex-end;">
                                                <div style="display: flex; gap: 8px; margin-bottom: 12px;">
                                                    <div style="height: 24px; line-height: 24px; color: #fff; text-align: center; font-size: 12px; font-weight: 700; background: #808080; border-radius: 4px; padding: 0 11px;">{{ each.contents.split('|||')[2] }}</div>
                                                    <div style="display: flex; align-items: center; justify-content: center; gap: 5px; height: 24px; line-height: 24px; color: #fff; text-align: center; font-size: 12px; font-weight: 700; background-color: #808080; border-radius: 4px;padding: 0 6px;">
                                                        <img style="width: 12px;" :src="require('@/assets/img/set_time.png')" alt="">
                                                        <div>{{ each.contents.split('|||')[3] }}</div>
                                                    </div>
                                                </div>
                                                <div style="color: #fff; font-size: 20px; font-weight: 700; line-height: 20px;">{{ each.contents.split('|||')[0] }}</div>
                                                <div style="margin-top: 12px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                                                    <div style="display: flex; justify-content: space-between;">
                                                        <div style="display: flex; align-items: center; height: 36px; width: 131px; border-radius: 12px; background-color: #fff; gap: 8px; justify-content: center;">
                                                            <img style="width: 14px;" :src="require('@/assets/img/go_training.png')" alt="">
                                                            <div style="font-weight: 700; font-size: 12px;">바로 훈련하기</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; bottom: 24px; height: 20px; text-align: right; padding-right: 24px; z-index: 10; display:inline-block;"></div>
                                </swiper>
                            </div> -->
                            <div style="margin-top: 20px;">
                                <div style="font-weight: 700; padding: 0 12px; margin-bottom: 6px;">
                                    <div>📝 감독의 노트</div>
                                </div>
                                <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; margin-bottom: 12px;">
                                    <div style="font-weight: 500; font-size: 13px; line-height: 24px; color: #808080;">감독님들의 축구 철학이 궁금하다면?!</div>
                                    <div @click="showSpotliteList" style="font-weight: 500; font-size: 13px; line-height: 24px; color: #808080; text-decoration: underline;">더보기</div>
                                </div>
                                <SwipedSelectedSpotLight style="padding-bottom: 0;" :spotlights="spotlights" />
                            </div>
                            <!-- <div ref="feedback_target">&nbsp;</div> -->
                            <LearnSoccer ref="learn_soccer_comp" :showRequestTestPopup="showRequestTestPopup" :eventBanner="eventBanner" :curViewTab="curViewTab" :setViewTab="setViewTab" :showPopularPostPopup="showPopularPostPopup" :noticeEvent="noticeEvent" :hideNoticeList="hideNoticeList" :noticeList="noticeListLearn" :refresh="refresh" :isExpertConfirmed="isExpertConfirmed" :mainData="mainData" :isExpert="isExpert" :soccerHows="soccerHows" :initRefreshFlag="initRefreshFlag" :refreshFlag="learnSoccerRefreshFlag" :popular-soccerhows="popular_soccerhows"></LearnSoccer>
                        </div>
                    </InfinityScroll>
                </div>


            </Transition>
        </div>
        <PageBottom :completeAction="makeFeedCompleteAction" :trainingBannerList="bannerList"></PageBottom>
        <BookmarkPopup :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
            <div>
                <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 24px; text-align: center;">
                    <img style="width: 100px; height: 100px; object-fit: contain;" :src="$resourcePath + teamImage" alt="">
                    <div style="color:#808080; font-size:12px; font-weight:bold; margin-top:3px;">{{ curPopTeam.name }}</div>
                </div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">관심있는 팀으로 등록했습니다.</div>
                <div @click="closeBookmarkPopup" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :background="'#fff'" :height="306" :isShowBookmarkPopup="isShowPopularPostPopup" :closeBookmarkPopup="closePopularPostPopup">
            <div>
                <div @click="closePopularPostPopup(false)" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 32px;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px;">이 공지·이벤트 피드를 숨기시겠어요?</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">지금 보신 공지는 피드에서 더 이상 표시되지 않아요.<br>하지만 새 공지나 이벤트가 생기면 다시 안내해드릴게요.</div>
                    <div @click="hideNotice" style="width: 186px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">확인</div>
                </div>
            </div>
        </BookmarkPopup>
        <MakeRequestJoinForm :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        <Transition name="fade">
            <div v-if="false" style="position: fixed; z-index: 200; background: #210F0380; width: 100%; height: 100%; left: 0; top: 0; backdrop-filter: blur(10px);">
                <div style="width: 350px; padding-bottom: 40px; text-align: center; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <div class="text_gradient_popup" style="font-weight: 800; font-size: 32px; line-height: 32px; padding-top: 50px;">{{ requestPrice }}</div>
                    <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; margin-top: 10px; text-decoration: line-through;">1회 30,000원</div>
                    <div v-html="popupTitle" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 17px;"></div>
                    <div style="margin-top: 8px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">내 잠재력과 열정을 감독님에게 직접 전달하고<br>입단 기회를 직접 얻어보세요!</div>
                    <div @click="closePopup" style="width: 196px; height: 56px; line-height: 56px; text-align: center; font-weight: 700; font-size: 14px; color: var(--color-main); margin: 0 auto; background-color: #210f03; border-radius: 50px; margin-top: 40px;">요청서 보낼 팀 찾기</div>
                    <div @click="hideSevenDays" style="font-weight: 500; font-size: 14px; line-height: 24px; margin-top: 12px; color: #808080;">7일동안 표시하지 않기</div>
                </div>
            </div>
        </Transition>
        <Transition name="fade">
            <div v-if="$GlobalStore.isShowPositionPopup()" style="position: fixed; z-index: 200; background: #210F0380; width: 100%; height: 100%; left: 0; top: 0; backdrop-filter: blur(10px);">
                <div style="width: 350px; padding-bottom: 40px; text-align: center; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <div @click="$GlobalStore.closePositionPopup()" style="font-weight: 700; line-height: 24px; padding-top: 16px; color: #808080; text-align: left; padding-left: 20px; margin-bottom: 20px;">닫기</div>
                    <div>
                        <img style="width: 204px;" :src="require('@/assets/img/position_stat.png')" alt="">
                    </div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 44px;">회원님의 진짜<br>포지션을 알아보세요</div>
                    <div style="margin-top: 8px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">전문가들이 직접 만든 알고리즘으로<br>회원님의 진짜 축구 포지션을 알아보세요</div>
                    <div @click="findPosition(); $Util.sendEventClick('포지션팝업_포지션찾기', true)" style="width: 196px; height: 56px; line-height: 56px; text-align: center; font-weight: 700; font-size: 14px; color: var(--color-main); margin: 0 auto; background-color: #210f03; border-radius: 50px; margin-top: 40px;">지금 포지션 찾기</div>
                </div>
            </div>
        </Transition>
        <div style="position: relative; z-index: 100;">
            <CommonPopupFrame :changeHeight="'auto'" :changeBottom="0" :isOpen="isShowRequestTestPopup" :closeCompleteAction="closeRequestTestPopup">
                <div style="padding: 0 24px;">
                    <div class="common_popup_header"></div>
                    <div style="margin-top: 30px;">
                        <div style="font-size: 20px; line-height: 32px; font-weight: 900;">입단 테스트에 도전해보시겠어요?</div>
                        <div style="font-size: 14px; font-weight: 500; color: #808080; line-height: 24px;">감독님들께 확실한 실력을 증명하기 위해,<br>아래 미션 중 하나로
                            <span style="font-weight: 700; color: #210f03;">입단 요청서 작성 기회</span>를 잡아보세요.
                        </div>
                        <div style="margin-top: 20px; padding-bottom: 20px; border-bottom: 1px solid #d9d9d9;">
                            <div>
                                <div style="font-weight: 700; font-size: 14px; line-height: 24px;">방법 1) 훈련 영상 3개 업로드</div>
                                <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">훈련 영상을
                                    <span style="font-weight: 700; color: var(--color-main)">직접 촬영해 3회 (하루 최대 1회)업로드</span>
                                    하면, 감독님에게 보낼 수 있는 입단 요청서를 바로 작성할 수 있어요!
                                </div>
                            </div>
                            <div style="margin-top: 15px;">
                                <div style="font-weight: 700; font-size: 14px; line-height: 24px;">방법 2) 인스타그램 이벤트</div>
                                <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">인스타그램 스토리에 사커하우 훈련 영상을 보고 직접 촬영한 영상을
                                    <span style="font-weight: 700; color: var(--color-main)">@soccerhow_official 태그</span>와 함께 업로드한 뒤, 캡쳐를 어플에 인증하면
                                    기다림 없이 즉시 입단 요청서 작성이 가능합니다.
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 10px; text-align: center;">
                            <div @click="showSelectType" style="font-weight: 700; font-size: 14px; line-height: 20px; text-decoration: underline;">혹시 엘리트 선수 이신가요?</div>
                            <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #808080;">joinKFA 등록 또는 1종팀 소속 이력을 증명하시면,<br>바로 입단 요청서 작성이 가능합니다</div>
                            <div style="margin-top: 10px; margin-bottom: 30px;">
                                <div @click="closeRequestTestPopup" class="common_btn">확인했어요</div>
                            </div>
                        </div>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>
    </div>
</template>

<script>
import SwipedSelectedSpotLight from '@/components/common/spotlight/SwipedSelectedSpotLight';
import GpsManager from "@/modules/GpsManager";
import NaverMap from "@/modules/NaverMap";
import PageBottom from '@/components/common/PageBottom'
import InfinityScroll from '@/components/common/InfinityScroll'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm';
import { SOCCER_HOW_TYPE, PAGE_NAME, NOTICE_LOCATION, NOTICE_TYPE } from '@/Constants'
import WebPushManager from '@/modules/WebPushManager'
import ResponseCode from '@/ResponseCode';
import ProgressBar from '@/components/soccerhowmain/ProgressBar';
// import InteractionOfFontColor from '@/components/common/InteractionOfFontColor';
import {PUSH_ACTION, TRIGGER_TYPE} from "../../Constants";
import moment from 'moment'
// import TrainingListModal from "@/components/soccerhowmain/TrainingListModal";
import LearnSoccer from '@/components/soccerhowmain/LearnSoccer';
// import ProfileImage from '@/components/common/ProfileImage'
import OptionBtn from '@/components/common/OptionBtn'
// import DivisionPositionText from '@/components/common/DivisionPositionText'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

const BTN_TYPE = {
    LEARN: 'LEARN',
    TRAINING: 'training'
}

const SORT_BTN_LIST_MODAL = {
    TEAM: '팀순',
    FAVORITE: '관심순',
    AGE: '나이대'
}

const VIEW_TAB = {
    POPULAR: '인기',
    REAL_TIME: '실시간'
}

const WEB_PUSH_TOKEN = 'WEB_PUSH_TOKEN';
const WEB_PUSH_TOKEN_STATE = 'WEB_PUSH_TOKEN_STATE';

export default {
    name: 'Ground',
    components: { PageBottom, SwipedSelectedSpotLight, ProgressBar, OptionBtn, LearnSoccer, InfinityScroll, BookmarkPopup, MakeRequestJoinForm, CommonPopupFrame },
    data() {
        return {
            isShowRequestTestPopup: false,
            PAGE_NAME: PAGE_NAME,
            BTN_TYPE: BTN_TYPE,
            curType: BTN_TYPE.LEARN,
            stickyTop: 0,
            joinSoccerTeamRefreshFlag: false,
            learnSoccerRefreshFlag: false,
            isShowBookmarkPopup: false,
            isEnableNextPageHandle: true,
            isEnableNextPageHandlePopular: true,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            soccerHows: [],
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 12, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
                autoplay: {
                    delay: 5000
                },
            },
            pageSoccerHows: 1,
            isShowMakeRequestJoinForm: false,
            pageRequest: 1,
            mainData: {},
            shortRequest: [],
            isShowBookmarkPopupNotExpert: false,
            isShowBookmarkPopupConfirmed: false,
            teamImage: '',
            curPopTeam: {},
            isStartJoin: false,
            isStartLearn: false,
            isHideLearn: true,
            isHideJoin: true,
            writeSoccerhows: {},
            noticeList: [],
            noticeListLearn: [],
            noticeListJoin: [],
            noticeEvent: [],
            NOTICE_LOCATION: NOTICE_LOCATION,
            NOTICE_TYPE: NOTICE_TYPE,
            isShowPopularPostPopup: false,
            popularNoticeIdx: -1,
            popularNoticeIndex: -1,
            isShowPopup: false,
            popular_soccerhows: [],
            popupTitle: '',
            requestPrice: '',
            winH: 0,
            device_gps_location: {},
            teamListData: {},
            fullSizeHeight: 0,
            sortBtnListModal: [
                { name: '모든 팀', key: SORT_BTN_LIST_MODAL.TEAM },
                { name: '관심순', key: SORT_BTN_LIST_MODAL.FAVORITE },
                { name: '모든 나이대', key: SORT_BTN_LIST_MODAL.AGE },
            ],
            sortBtnKeysModal: {
                [SORT_BTN_LIST_MODAL.TEAM]: SORT_BTN_LIST_MODAL.TEAM,
                [SORT_BTN_LIST_MODAL.FAVORITE]: '',
                [SORT_BTN_LIST_MODAL.AGE]: SORT_BTN_LIST_MODAL.AGE,
            },
            sortBtnValuesModal: {
                [SORT_BTN_LIST_MODAL.TEAM]: '',
                [SORT_BTN_LIST_MODAL.FAVORITE]: '',
                [SORT_BTN_LIST_MODAL.AGE]: '',
            },
            isShowPopMenu: false,
            modalListType: null,
            modalListSort: null,
            modalListAge: null,
            isOpenSoccerTeamListModal: false,
            naverMap: null,
            schedules: [],
            is_soccer_learn_loaded: false,
            trainingList: [],
            VIEW_TAB: VIEW_TAB,
            curViewTab: VIEW_TAB.POPULAR,
            pagePopular: 1,
            curScrollTopPopular: 0,
            curScrollTopRealTime: 0,
            bannerList: [],
            eventBanner: [],
            isShowTopBtn: true,
            screen_stay_settimeout : null,
            spotlights: [],
        }
    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.isLogin()) {
                if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        isExpertConfirmed() {
            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_coach === '1') {
                return true
            } else {
                return false
            }
        },
        isFinalConfirmed() {
            if (this.isExpert && this.isExpertConfirmed && this.$GlobalStore.loginInfo().is_coach_confirmed === '0') {
                return false
            } else {
                return true
            }
        },
        myImagePath() {
            if (this.$GlobalStore.isLogin()) {
                return this.$GlobalStore.loginInfo().image_path
            } else {
                return null
            }
        }
    },
    async mounted() {
        if (this.$hasOwnProperty(this.$route.query, 'target')) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: this.$route.query.target });
        }

        if (location.pathname === '/training_main') {
            this.$Util.checkAppLinkPageShow(PUSH_ACTION.MERCENARY);
            this.setTopBtn(BTN_TYPE.TRAINING);
        } else {
            this.$Util.checkAppLinkPageShow(PUSH_ACTION.HOME_LEARN);
        }
    },
    deactivated() {
        if(this.screen_stay_settimeout) clearTimeout(this.screen_stay_settimeout);
    },
    async created() {
        //그라운드 페이지 채류 시간에 따른 트리거
        if(this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '0'){
            this.screen_stay_settimeout = setTimeout(() => {
                const parameters = {};
                parameters.trigger_type = TRIGGER_TYPE.LURKING_ESCAPE;
                this.$Axios.post('/api/member/trigger/save', parameters)
            }, 1000 * 300);
        }


        this.fullSizeHeight = this.$GlobalStore.statusBarHeight() + this.$GlobalStore.navigationBarHeight()
        const today = moment()
        const targetDate = moment('2099-06-20', 'YYYY-MM-DD')

        if (today.isAfter(targetDate)) {
            this.popupTitle = '감독님에게 직접 보내는 입단 요청서<br>딱 한달동안 자유롭고 부담없이'
            this.requestPrice = '9,900'
        } else {
            this.popupTitle = '감독님에게 직접 보내는 입단 요청서<br>6월 20일까지 자유롭고 부담없이'
            this.requestPrice = '무료!'
        }

        this.checkPermssion = this.$Once(this.checkPermssion)
        this.unlikeTeam = this.$Once(this.unlikeTeam)
        this.likeTeam = this.$Once(this.likeTeam)
        if (location.pathname === '/training_main') {
            this.curType = BTN_TYPE.TRAINING;
        } else {
            this.is_soccer_learn_loaded = true;
        }
        await Promise.all([
            // this.getNoticeList(),
            this.getSpotlights(),
            this.getMainData(),
            // this.getShortRequest(),
            this.getLearnFeedData(),
            this.getPopularSoccerhow(),
            this.getBannerList()

        ])

        if (this.$route.query.is_from_popup === 'true') {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.setViewTab(VIEW_TAB.REAL_TIME)
                }, 500);
            })
        }

        if (this.$route.query.is_from_popup_video === 'true') {
            this.$nextTick(() => {
                const nearCoachBox = this.$refs.learn_soccer_comp.$refs.near_coach
                nearCoachBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            })
        }

        if (this.$hasOwnProperty(this.$route.query, 'is_go_feedback')) {
            this.$refs.feedback_target.scrollIntoView({ behavior: "smooth"})
        }

        setTimeout(() => {
            const scrollWrap = this.$refs.infinity.$refs.scrollWrap
            const tabBox = this.$refs.learn_soccer_comp.$refs.tab_wrapper
            this.stickyTop =
                tabBox.getBoundingClientRect().top +
                scrollWrap.scrollTop -
                parseInt(window.getComputedStyle(tabBox).top || 0) -
                this.$GlobalStore.statusBarHeight()
        }, 500)

        if (!this.isFinalConfirmed) {
            setTimeout(() => {
                this.isShowBookmarkPopupConfirmed = true
            }, 500)
        }
    },
    methods: {
        showSpotliteList() {
            this.$GlobalStore.addModal('SpotLightList',)
        },
        async getSpotlights() {
            const res = await this.$Axios.get('/api/spotlight/list/random')
            this.spotlights = res.data.spotlights
        },
        showRequestTestPopup() {
            this.isShowRequestTestPopup = true
        },
        showSelectType() {
            this.$GlobalStore.addModal('SelectPlayerType')
        },
        closeRequestTestPopup() {
            this.isShowRequestTestPopup = false
        },
        makeFeedCompleteAction() {
            this.$refs.learn_soccer_comp.getLearnData();
            this.$refs.learn_soccer_comp.refresh();
        },
        setIsShowTopBtn(isShow) {
            this.isShowTopBtn = isShow
        },
        showBannerDetail(bannerIdx) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.$Util.sendEventClick('감독의시선_자세히보기', true)
            this.$GlobalStore.addModal('LearnBannerDetail', { bannerIdx: bannerIdx, completeAction: this.refresh, isModalBackTransparent: true, })
        },
        async getBannerList() {
            const res = await this.$Axios.get('/api/soccerhow/learn/banner')

            const bannerList = res.data.banner_list
            const event_banner = res.data.event_banner

            this.bannerList = bannerList
            this.eventBanner = event_banner
        },
        __conveyScrollTop(scrollTop) {
            if (this.curViewTab === VIEW_TAB.POPULAR) {
                this.curScrollTopPopular = scrollTop
            } else {
                this.curScrollTopRealTime = scrollTop
            }
        },
        setViewTab(type) {
            this.curViewTab = type
            if (this.curViewTab === VIEW_TAB.POPULAR) {
                this.$nextTick(() => {
                    if (this.curScrollTopPopular > this.stickyTop) {
                        this.$refs.infinity.$refs.scrollWrap.scrollTop = this.curScrollTopPopular
                    } else {
                        this.$refs.infinity.$refs.scrollWrap.scrollTop = this.stickyTop
                    }
                })
            } else {
                this.$nextTick(() => {
                    if (this.curScrollTopRealTime > this.stickyTop) {
                        this.$refs.infinity.$refs.scrollWrap.scrollTop = this.curScrollTopRealTime
                    } else {
                        this.$refs.infinity.$refs.scrollWrap.scrollTop = this.stickyTop
                    }
                })
            }
        },
        async getTeamTrainingList() {
            const res = await this.$Axios.get('/api/home/training')
            this.schedules = res.data.schedules
            this.updateMarkerMercenary()
        },
        async setMap() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();

            if (process.env.NODE_ENV === 'production') {
                const gpsLocation = await GpsManager.getLocation();
                this.device_gps_location = gpsLocation;
            } else {
                this.device_gps_location = { latitude: '37.473627', longitude: '127.009505' };
            }

            if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
            const map = new NaverMap();
            // let viewOption = this.viewOption;
            let initialLocation = await this.getInitialLocation();
            initialLocation;
            if (this.$GlobalStore.isLogin()) {
                map.initMap('map', this.$GlobalStore.loginInfo().place_gps_latitude, this.$GlobalStore.loginInfo().place_gps_longitude, { zoom: 10, minZoom: 7, maxZoom: 17 });
            } else {
                map.initMap('map', this.device_gps_location.latitude, this.device_gps_location.longitude, { zoom: 10, minZoom: 7, maxZoom: 17 });
            }

            this.map = map;
            this.$nextTick(() => {
                this.centerActivityLocation()
            });

            this.naverMap = this.map;

            //네이버 로고 내리기
            setTimeout(() => {
                const map_children = document.getElementById('map').childNodes;
                if (map_children[4]) map_children[4].style.zIndex = 0;
            }, 200);

            // this.$nextTick(() => {
            //     this.$refs.modal_wrapper.scrollTop = 275
            // })
            this.getTeamTrainingList();
        },
        openSoccerTeamListModal() {
            this.isOpenSoccerTeamListModal = true
        },
        closeSoccerTeamListModal() {
            this.isShowIcon = false
            this.isOpenSoccerTeamListModal = false
        },
        setSortCondition(type, value) {
            if (type === SORT_BTN_LIST_MODAL.TEAM) {
                if (value === '모든 팀') {
                    this.modalListType = null
                } else {
                    this.modalListType = value
                }
            } else if (type === SORT_BTN_LIST_MODAL.FAVORITE) {
                this.modalListSort = value
            } else if (type === SORT_BTN_LIST_MODAL.AGE) {
                if (value === '모든 나이대') {
                    this.modalListAge = null
                } else {
                    this.modalListAge = value
                }
            }

            this.getTeamList()
        },
        showPopupMenuModal(key, index) {
            this.isShowPopMenu = true
            const labelAndAction = [];
            if (key === SORT_BTN_LIST_MODAL.TEAM) {
                labelAndAction.push(
                    {
                        label: '모든 팀', action: () => {
                            this.sortBtnListModal[index].name = '모든 팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '모든 팀';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '프로축구팀', action: () => {
                            this.sortBtnListModal[index].name = '프로축구팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '프로축구팀';
                            this.isShowPopMenu = false;
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '유스팀', action: () => {
                            this.sortBtnListModal[index].name = '유스팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '유스팀';
                            this.isShowPopMenu = false;
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '1종 전문축구팀', action: () => {
                            this.sortBtnListModal[index].name = '1종 전문축구팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '1종 전문축구팀';
                            this.isShowPopMenu = false;
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '2종 축구팀', action: () => {
                            this.sortBtnListModal[index].name = '2종 축구팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '2종 축구팀';
                            this.isShowPopMenu = false;
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '동호인 축구팀', action: () => {
                            this.sortBtnListModal[index].name = '동호인 축구팀'
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '동호인 축구팀';
                            this.isShowPopMenu = false;
                            this.setSortCondition(SORT_BTN_LIST_MODAL.TEAM, this.sortBtnValuesModal[key])
                        },
                    }

                )
            } else if (key === SORT_BTN_LIST_MODAL.FAVORITE) {
                labelAndAction.push(
                    {
                        label: '관심순', action: () => {
                            this.sortBtnListModal[index].name = '관심순';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '관심순';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.FAVORITE, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '이름순', action: () => {
                            this.sortBtnListModal[index].name = '이름순';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '이름순';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.FAVORITE, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: '추가된 날짜순', action: () => {
                            this.sortBtnListModal[index].name = '추가된 날짜순';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '추가된 날짜순';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.FAVORITE, this.sortBtnValuesModal[key])
                        },
                    },
                )
            } else if (key === SORT_BTN_LIST_MODAL.AGE) {
                labelAndAction.push(
                    {
                        label: '모든 나이대', action: () => {
                            this.sortBtnListModal[index].name = '모든 나이대';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = '모든 나이대';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.AGE, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: 'U12', action: () => {
                            this.sortBtnListModal[index].name = 'U12';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = 'U12';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.AGE, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: 'U15', action: () => {
                            this.sortBtnListModal[index].name = 'U15';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = 'U15';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.AGE, this.sortBtnValuesModal[key])
                        },
                    },
                    {
                        label: 'U18', action: () => {
                            this.sortBtnListModal[index].name = 'U18';
                            // this.selectedSortKey = key
                            this.sortBtnKeysModal[key] = key;
                            this.sortBtnValuesModal[key] = 'U18';
                            this.isShowPopMenu = false
                            this.setSortCondition(SORT_BTN_LIST_MODAL.AGE, this.sortBtnValuesModal[key])
                        },
                    },
                )
            }

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        updateMarkerMercenary() {
            this.naverMap.clear();

            let overlayCreatorSoccerList = (item, html, lat, lng, zIndex) => {
                let handler = () => {
                    this.$Util.sendEventClick('트레이닝_지도_팀상세보기', true)
                    this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: item.idx })
                }
                let touchStart = (element) => {
                    element.style.transition = 'all 0.2s'
                    element.style.scale = '0.95'
                    element.style.transformOrigin = '10% 10%'
                }
                let touchEnd = (element) => {
                    element.style.scale = '1'
                }
                this.naverMap.drawOverlay(html, lat, lng, html, handler, zIndex, touchStart, touchEnd);
            }
            if (this.curType === BTN_TYPE.TRAINING) {
                this.schedules.forEach(item => {
                    const markerHtml = this.$Util.Mercenary.Marker.trainingMarker(item)
                    overlayCreatorSoccerList(item, markerHtml, item.gps_latitude || item.gps_latitude, item.gps_longitude || item.gps_longitude, 10)
                })
            }
        },
        async getTeamList() {
            const parameters = {}
            if (this.modalListType) {
                parameters.type = this.modalListType
            }
            if (this.modalListSort) {
                parameters.sort = this.modalListSort
            }
            if (this.modalListAge) {
                parameters.age = this.modalListAge
            }
            const res = await this.$Axios.get('/api/team/map/list', { params: parameters })
            const teamListData = res.data
            this.teamListData = teamListData
            this.updateMarkerMercenary()
        },
        getMyMarkerHtml(isSchedule = false) {
            if (isSchedule) {
                return null
            } else {
                return `
                <div style="width:1px; height:1px;">
                    <div style="position:relative; width:110px; height:110px; transform: translate(-50%, -50%);">
                        <div style="position:absolute; width:50px; height:50px; left:30px; top:30px;background: rgba(0, 66, 255, 0.5);opacity: 0.15; border-radius:50%;"></div>
                        <div style="position:absolute; left:47px; top:47px; width:16px; height:16px; border-radius:50%; background-color:#1666f1; border:2.5px solid white;"></div>
                    </div>
                </div>
                `;
            }
        },
        centerCurrentLocation() {
            if (this.$GlobalStore.isFromJoinChat().state) {
                this.naverMap.setCenter(this.$GlobalStore.isFromJoinChat().lat, this.$GlobalStore.isFromJoinChat().long);
                this.$GlobalStore.setIsFromJoinChat({ state: false, lat: '', long: '' })
            } else {
                this.naverMap.setCenter(this.device_gps_location.latitude, this.device_gps_location.longitude);
            }
            this.naverMap.drawMyLocationMarker(this.getMyMarkerHtml(), this.device_gps_location.latitude, this.device_gps_location.longitude, true);
            this.updateSearchResult(true);
        },
        setCenter(lat, lon) {
            this.naverMap.setCenter(lat, lon)
        },
        updateSearchResult() {
            let mapCenter = this.naverMap.getMapInstance().getCenter()
            const center_lat = mapCenter.lat();
            const center_lng = mapCenter.lng();

            this.centerGps = {
                center_lat: center_lat,
                center_lng: center_lng
            }
        },
        async centerActivityLocation() {
            if (this.$GlobalStore.isLogin()) {
                const [is_default_complete] = this.$Util.checkDefaultMemberInfoComplete();
                if (!is_default_complete) {
                    return
                }

                if (!(this.$GlobalStore.loginInfo().place_gps_latitude)) {
                    this.$GlobalStore.showAlert('활동장소를 지정하지 않았습니다.');
                    return;
                }
                const place_gps_latitude = this.$GlobalStore.loginInfo().place_gps_latitude
                const place_gps_longitude = this.$GlobalStore.loginInfo().place_gps_longitude

                this.naverMap.setCenter(place_gps_latitude, place_gps_longitude);
            } else {
                this.naverMap.setCenter(this.device_gps_location.latitude, this.device_gps_location.longitude);
            }
        },
        async getInitialLocation() {
            let initialLocation
            // if (viewOption === 1) {
            if (this.$GlobalStore.isLogin()) {
                initialLocation = { 'lat': this.$GlobalStore.loginInfo().place_gps_latitude, 'lng': this.$GlobalStore.loginInfo().place_gps_longitude };
            } else {
                initialLocation = { 'lat': this.device_gps_location.latitude, 'lng': this.device_gps_location.longitude };
            }
            // }

            return initialLocation;
        },
        handleResize() {
            this.winH = window.innerHeight;
        },
        async getPopularSoccerhow() {
            this.isEnableNextPageHandlePopular = false
            const parameters = {}
            parameters.types = [SOCCER_HOW_TYPE.GROUP_TRAINING, SOCCER_HOW_TYPE.SINGLE_TRAINING];
            parameters.page = this.pagePopular
            const res = await this.$Axios.get('/api/soccerhow/popular/soccerhow_type', { params: parameters });
            const popular_soccerhows = res.data.popular_soccerhows

            if (popular_soccerhows.length > 0) {
                this.isEnableNextPageHandlePopular = true
                this.popular_soccerhows = [...this.popular_soccerhows, ...popular_soccerhows]
            }
            // 인기게시글 테스트
            // for (let index = 0; index < 10; index++) {
            //     this.popular_soccerhows.push(this.popular_soccerhows[0])

            // }
        },
        findPosition() {
            this.$GlobalStore.closePositionPopup()
            this.$GlobalStore.addModal('SelectFindPosition')
            // this.$GlobalStore.addModal('FindPositionProMain', {});
        },
        hideSevenDays() {
            const now = new Date();
            const hideSevenDays = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
            // const hideSevenDays = new Date(now.getTime() + 10 * 1000);
            localStorage.setItem('HIDE_SEVEN_DAYS', hideSevenDays.toISOString());
            this.isShowPopup = false;
        },
        closePopup() {
            this.isShowPopup = false
            this.$router.push({ path: '/view/mercenary' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        setIsShowPopup() {
            const isHide = localStorage.getItem('HIDE_SEVEN_DAYS');
            if (isHide) {
                const hideSevenDays = new Date(isHide);
                const now = new Date();
                if (hideSevenDays < now) {
                    this.isShowPopup = true;
                }
                return
            }
            this.isShowPopup = true
        },
        async hideNotice() {
            const formData = new FormData()
            formData.append('notice_idx', this.popularNoticeIdx)

            const res = await this.$Axios.post('/api/notice/hide', formData)

            if (res.data.code === 0) {
                this.hideNoticeList(true, this.popularNoticeIndex, NOTICE_TYPE.EVENT)
                this.closePopularPostPopup()
            }
        },
        closePopularPostPopup() {
            this.popularNoticeIdx = -1
            this.popularNoticeIndex = -1
            this.isShowPopularPostPopup = false
        },
        showPopularPostPopup(postInfo, index) {
            this.popularNoticeIdx = postInfo.idx
            this.popularNoticeIndex = index
            this.isShowPopularPostPopup = true
        },
        hideNoticeList(isFeed, index, notice_type) {
            if (notice_type === NOTICE_TYPE.NOTICE) {
                if (isFeed) {
                    this.$delete(this.noticeListLearn, index)
                } else {
                    this.$delete(this.noticeListJoin, index)
                }
            } else {
                if (isFeed) {
                    this.$delete(this.noticeEvent, index)
                } else {
                    this.$delete(this.noticeListJoin, index)
                }
            }
        },
        sortNoticeList(sortArr) {
            sortArr.sort((a, b) => new Date(b.insert_date) - new Date(a.insert_date))
        },
        setNoticeList() {
            this.noticeList.forEach(item => {
                if (item.notice_type === NOTICE_TYPE.EVENT && item.notice_location === NOTICE_LOCATION.LEARN_SOCCER) {
                    this.noticeEvent.push(item)
                    this.sortNoticeList(this.noticeEvent)
                }
                if (item.notice_type === NOTICE_TYPE.NOTICE && item.notice_location === NOTICE_LOCATION.LEARN_SOCCER) {
                    this.noticeListLearn.push(item)
                    this.sortNoticeList(this.noticeListLearn)
                } else if (item.notice_location === NOTICE_LOCATION.JOIN_SOCCER_TEAM) {
                    this.noticeListJoin.push(item)
                    this.sortNoticeList(this.noticeListJoin)
                }
            })
        },
        async getNoticeList() {

            const parameters = {};
            const res = await this.$Axios.get('/api/notice/list', { params: parameters });
            const noticeList = res.data.notice_list;

            this.noticeList = noticeList
            this.setNoticeList()
        },
        testAds() {
            // window.completeRewardAds = (reward_type, amount) => {
            //     reward_type; amount;
            //     // setTimeout(() => { alert(reward_type + ' => ' + amount)}, 5000);
            // };
            // /*eslint-disable no-undef */
            // webkit.messageHandlers.ios.postMessage({ cmd: 'showRewardAds' });
        },
        showSearch() {
            this.$GlobalStore.addModal('IntergrationSearch', { pageName: PAGE_NAME.HOME })
        },
        detectScroll(e) {
            if (this.$refs.learn_soccer_comp) {
                this.$refs.learn_soccer_comp.__detectScroll(e);
            }

            if (this.$refs.join_soccer_team_comp) {
                this.$refs.join_soccer_team_comp.__detectScroll(e);
            }
        },
        async showInquiryPopup() {
            if (this.$Util.isApp()) {
                await this.$Util.showChatWithAdmin();
            } else {
                if (this.$hasOwnProperty(localStorage, WEB_PUSH_TOKEN)
                    && (this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'nologin')
                    && (!this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'login')
                ) {
                    await this.$Util.showChatWithAdmin();
                } else {
                    const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">PUSH알림을 허용해주세요.</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>브라우저 PUSH알림을 잠깐만 켜두시면<br>더 빠르고 원활하게 답변을 받을 수 있어요</div>`
                    this.$GlobalStore.showConfirm(html, this.showChatting, '확인', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
                }
            }
        },
        async checkPermssion() {
            let [isSuccess, token] = await WebPushManager.requestPermission();
            if (isSuccess) {
                const parameters = {};
                parameters.token = token;
                const res = await this.$Axios.post('/api/nologin/device/push/set', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    localStorage.setItem(WEB_PUSH_TOKEN, token);
                    localStorage.setItem(WEB_PUSH_TOKEN_STATE, this.$GlobalStore.isLogin() ? 'login' : 'nologin');
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        async showChatting() {
            await this.checkPermssion();
            this.$Util.showChatWithAdmin();
        },
        setMakeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = true
            // this.$Util.checkAppLinkPageShow();
        },
        setTopBtn(type) {
            this.curType = type
            if (this.curType === BTN_TYPE.LEARN) this.is_soccer_learn_loaded = true;
            if (this.$GlobalStore.isLogin()) {
                if (this.curType === BTN_TYPE.TRAINING && this.$GlobalStore.loginInfo().is_temp_coach != 1) {
                    setTimeout(() => {
                        this.setIsShowPopup()
                    }, 500);
                }
            }
            if (this.curType === BTN_TYPE.TRAINING && !this.map) {
                this.setMap()
            }
        },
        closeRequestJoinForm(isSave = false, soccerhowIdx) {
            if (isSave) {
                this.refresh(isSave, soccerhowIdx)
            }
            this.isShowMakeRequestJoinForm = false
        },
        refresh(isWrite = false) {
            this.noticeList = []
            this.noticeListJoin = []
            this.noticeListLearn = []
            this.noticeEvent = []
            this.getNoticeList()
            if (this.curType === BTN_TYPE.TRAINING) {
                if (!isWrite) {
                    this.joinSoccerTeamRefreshFlag = true
                    this.shortRequest = []
                    this.pageRequest = 1
                    this.getShortRequest()
                    this.getMainData();
                } else {
                    this.pageRequest = 1
                    this.isHideJoin = false
                    setTimeout(() => {
                        this.isStartJoin = true
                    }, 300)
                }
            } else {
                if (!isWrite) {
                    if (this.curViewTab === VIEW_TAB.POPULAR) {
                        this.popular_soccerhows = []
                        this.pagePopular = 1
                        this.getPopularSoccerhow()
                    } else {
                        this.soccerHows = []
                        this.pageSoccerHows = 1
                        this.getMainData();
                        this.getLearnFeedData()
                    }
                    this.learnSoccerRefreshFlag = true
                    this.getBannerList()
                } else {
                    this.pageSoccerHows = 1
                    this.isHideLearn = false
                    this.isStartLearn = true
                }
            }
        },
        handleNextPage() {
            if (this.curType === BTN_TYPE.TRAINING) {
                this.pageRequest++
                this.getShortRequest()
            } else {
                if (this.curViewTab === VIEW_TAB.POPULAR) {
                    this.pagePopular++
                    this.getPopularSoccerhow()
                } else {
                    this.pageSoccerHows++
                    this.getLearnFeedData()
                }
            }
        },
        async getMainData() {
            const res = await this.$Axios.get('/api/home/target/main')
            const mainData = res.data
            this.mainData = mainData
        },
        // async getLearnData() {
        //     const res = await this.$Axios.get('/api/home/target/learn')
        //     const learnData = res.data.soccerhows
        //     learnData
        // },
        completeAction() {
            if (this.curType === BTN_TYPE.TRAINING) {
                this.getShortRequest(true)
                this.isStartJoin = false
                this.isHideJoin = true
            } else {
                this.getLearnFeedData(true)
                this.isStartLearn = false
                this.isHideLearn = true
            }
        },
        async getLearnFeedData(isWrite = false) {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.pageSoccerHows
            parameters.type = SOCCER_HOW_TYPE.GROUP_TRAINING + ',' + SOCCER_HOW_TYPE.SINGLE_TRAINING
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const soccerHows = res.data.soccerHows

            if (isWrite) {
                this.soccerHows = soccerHows
                this.isEnableNextPageHandle = true
                return
            }

            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                this.soccerHows = [...this.soccerHows, ...soccerHows]
            }
        },
        async getShortRequest(isWrite) {
            this.isEnableNextPageHandle = false
            const types = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            const parameters = {};
            parameters.page = this.pageRequest
            parameters.type = types
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;
            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const shortRequest = res.data.soccerHows

            if (isWrite) {
                this.shortRequest = shortRequest
                this.isEnableNextPageHandle = true
                return
            }

            if (shortRequest.length > 0) {
                this.isEnableNextPageHandle = true
                this.shortRequest = [...this.shortRequest, ...shortRequest]
            }
        },
        initRefreshFlag() {
            this.joinSoccerTeamRefreshFlag = false
            this.learnSoccerRefreshFlag = false
        },
        setBookmarkPopup(index, teamDetail) {
            if (!teamDetail.is_me_liked) {
                this.isShowBookmarkPopup = true
            }
            if (teamDetail.is_me_liked) {
                this.unlikeTeam(index, teamDetail)
            } else {
                this.teamImage = teamDetail.image_path
                this.curPopTeam = teamDetail;
                this.likeTeam(index, teamDetail)
            }
        },
        async unlikeTeam(index, teamDetail) {
            let likeCnt = parseInt(this.mainData.teams[index].like_cnt) - 1
            const formData = new FormData()
            formData.append('target_idx', teamDetail.idx)
            const res = await this.$Axios.post('/api/like/team/delete', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$set(this.mainData.teams[index], 'is_me_liked', false)
                this.$set(this.mainData.teams[index], 'like_cnt', likeCnt)
            }
        },
        async likeTeam(index, teamDetail) {
            let likeCnt = parseInt(this.mainData.teams[index].like_cnt) + 1
            const formData = new FormData()
            formData.append('target_idx', teamDetail.idx)

            const res = await this.$Axios.post('/api/like/team/save', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$set(this.mainData.teams[index], 'is_me_liked', true)
                this.$set(this.mainData.teams[index], 'like_cnt', likeCnt)
            }
        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
            this.teamImage = ''
            this.curPopTeam = {};
        }
    }
}
</script>

<style scoped>
.common_btn {
    padding: 16px 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 12px;
    background-color: #000;
    text-align: center;
}

.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.float_btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 4px 36px rgba(33, 15, 3, 0.08);
    backdrop-filter: blur(2.5px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.top_btn {
    width: 98px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}

.text_gradient_popup {
    background: linear-gradient(180deg, #4B8AFF 0%, #43CDFF 100%);
    -webkit-background-clip: text;
    color: transparent;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: #bbb;
    opacity: 1;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: var(--color-main);
    width: 21px;
    height: 6px;
    border-radius: 8px;
}
</style>